import { FunctionComponent } from 'react';
import './Breadcrumbs.scss';
import { Breadcrumb } from 'antd';
import { IBreadcrumbs } from './types';
import { useTranslation } from 'react-i18next';

const { Item } = Breadcrumb;

const Breadcrumbs: FunctionComponent<IBreadcrumbs> = ({ data }): JSX.Element => {
  const { t } = useTranslation();
  return (
    <Breadcrumb>
      {data.map((item: string, index: number) => {
        const value = t(item);
        return <Item key={index}>{data.length === index ? <strong>{value}</strong> : value}</Item>;
      })}
    </Breadcrumb>
  );
};

export default Breadcrumbs;
